// extracted by mini-css-extract-plugin
module.exports = {"container":"Screen_container__2xle6","content":"Screen_content__HkYKy"};